import { motion } from "framer-motion";

const sections = [
  {
    title: "1. Veri Sorumlusu",
    content: `
6698 sayılı KVKK uyarınca kişisel verileriniz, veri sorumlusu sıfatıyla Uzman Klinik Psikolog Aysun Şeremet tarafından aşağıda açıklanan kapsamda işlenebilecektir.
`
  },
  {
    title: "2. İşlenen Kişisel Veriler",
    content: `
Web sitesi ve iletişim kanalları aracılığıyla aşağıdaki kişisel veriler işlenebilmektedir:
• Kimlik bilgileri (ad, soyad)
• İletişim bilgileri (telefon numarası, e-posta adresi)
• Mesaj ve başvuru içerikleri
• Web sitesi kullanımına ilişkin teknik veriler (IP adresi, çerez verileri, tarayıcı bilgileri)
`
  },
  {
    title: "3. Kişisel Verilerin İşlenme Amaçları",
    content: `
Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenebilmektedir:
• Psikolojik danışmanlık hizmetlerinin sunulması
• Randevu süreçlerinin planlanması ve yürütülmesi
• Danışan ile iletişim kurulması
• Web sitesi kullanımının iyileştirilmesi
• Yasal ve hukuki yükümlülüklerin yerine getirilmesi
`
  },
  {
    title: "4. Kişisel Verilerin Aktarılması",
    content: `
Kişisel verileriniz, KVKK’nın 8. ve 9. maddelerine uygun olarak aşağıdaki kişi ve kurumlarla sınırlı olmak üzere paylaşılabilir:
• Yasal zorunluluklar kapsamında yetkili kamu kurum ve kuruluşları
• Web sitesi ve teknik altyapı hizmeti sağlayıcıları
• Hukuki süreçlerde yetkili merciler
`
  },
  {
    title: "5. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi",
    content: `
Kişisel verileriniz;
• Web sitesi iletişim formları
• E-posta ve telefon iletişimi
• Web sitesi çerezleri

aracılığıyla otomatik veya otomatik olmayan yöntemlerle toplanabilir.

Bu veriler, KVKK’nın 5. maddesinde belirtilen hukuki sebeplere dayanarak işlenmektedir.
`
  },
  {
    title: "6. KVKK Kapsamındaki Haklarınız",
    content: `
KVKK’nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:
• Kişisel verilerinizin işlenip işlenmediğini öğrenme
• İşlenmişse buna ilişkin bilgi talep etme
• Eksik veya yanlış işlenmiş verilerin düzeltilmesini isteme
• Kişisel verilerin silinmesini veya yok edilmesini talep etme
• İşlemeye itiraz etme
• Kanuna aykırı işleme nedeniyle zarara uğramanız halinde tazminat talep etme
`
  },
  {
    title: "7. Başvuru ve İletişim",
    content: `
KVKK kapsamındaki taleplerinizi aşağıdaki iletişim adresi üzerinden iletebilirsiniz:

E-posta: info@aysunseremet.com
`
  }
];

export default function ClarificationText() {
  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-12">
      
      {/* Başlık */}
      <motion.div
        className="max-w-4xl mx-auto text-center space-y-6"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        <h1 className="text-4xl font-bold text-gray-900">
          Aydınlatma Metni
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl max-w-2xl mx-auto">
          Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, web sitesi ziyaretçilerinin ve danışanların kişisel verilerinin işlenmesine ilişkin olarak bilgilendirilmesi amacıyla hazırlanmıştır.
        </p>
      </motion.div>

      {/* İçerik */}
      <div className="mt-16 max-w-3xl mx-auto space-y-6">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.8,
              delay: index * 0.1,
              ease: "easeInOut",
            }}
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {section.title}
            </h2>

            {section.content.split("\n").map((line, i) =>
              line.trim() ? (
                <p key={i} className="text-gray-700 leading-relaxed mb-2">
                  {line}
                </p>
              ) : null
            )}
          </motion.div>
        ))}
      </div>

    </section>
  );
}